import { Component, Prop, h } from '@stencil/core';
@Component({
  tag: 'banner-error',
  styleUrl: 'banner-error.css',
  shadow: true,
})
export class BannerError {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() hiddenMode: boolean = false;

  shouldDisplayError() {
    return this.hasError && this.errorMessage;
  }

  render() {
    const shouldDisplayError = this.shouldDisplayError();
    const classList = {
      'flex text-xs leading-4 text-white mt-[2px]': true,
      'opacity-0': !shouldDisplayError && !this.hiddenMode,
      hidden: !shouldDisplayError && this.hiddenMode,
    };

    return (
      <div>
        <span class={classList}>
          <icon-alert class="mr-2 w-4 h-4 fill-white" />
          {this.errorMessage}
        </span>
      </div>
    );
  }
}
